<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../../../_shared/_logic/rich-tooltips"
  import { buildInboxSourceTag } from "../../_logic/cells-presentation"

  let {
    label = "",
    subLabel = null,
    disabled = false,
  }: { label?: string; subLabel?: string | null; disabled?: boolean } = $props()

  const tag = $derived(buildInboxSourceTag(label, subLabel))
</script>

<span class="inbox-cell-tag" class:disabled>
  <StatusTag
    variant="neutral"
    size="sm"
    label={tag.label}
    subLabel={tag.subLabel ?? undefined}
    color={tag.color}
    icon={tag.icon}
    tooltipContent={tag.tooltip}
    tooltipHtml={true}
    tooltipClassName={RICH_TOOLTIP_CLASS}
    disableTitle={true}
  />
</span>

<style>
  .inbox-cell-tag {
    display: inline-flex;
    max-width: 100%;
  }

  .inbox-cell-tag.disabled {
    opacity: 0.54;
  }
</style>
